import React, { useEffect, useRef, useState } from "react";
import './UpsaleActivity.css'
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
import RadioChecked from "../../svg/radioChecked";
import RadioEmpty from "../../svg/radioEmpty";
import { FocusTrap } from "focus-trap-react";
export default function UpsaleActivity(props) {

    const [selectedCampaign, setSelectedCampaign] = useState(undefined);
    const [selectedCheckb, setSelectedCheckb] = useState(4);
    const store = useSelector(store => store.reducer);
    const { activityHours, ...upsaleData } = props.upsaleActivities || {};
    const extraPayment = ((props.visitors?.adults || 0) * (upsaleData.price?.adults || 0)) + ((props.visitors?.underAge || 0) * (upsaleData.price?.underAge || 0))
    const dialogRef = useRef(null);
    const closeButtonRef = useRef(null);

    const handleCheckBoxClick = (item) => {
        setSelectedCheckb(item.Id)
        setSelectedCampaign(item) 
    }

    const handleKeyDown = (e, item) => {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Space') {
            e.preventDefault();
            handleCheckBoxClick(item);
        } else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
            e.preventDefault();
            const currentIndex = activityHours.findIndex(hour => hour.Id === item.Id);
            const nextIndex = (currentIndex + 1) % activityHours.length;
            handleCheckBoxClick(activityHours[nextIndex]);
            document.getElementById(`activitydetailcardtimes_${activityHours[nextIndex].Id}`)?.focus();
        } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
            e.preventDefault();
            const currentIndex = activityHours.findIndex(hour => hour.Id === item.Id);
            const prevIndex = currentIndex === 0 ? activityHours.length - 1 : currentIndex - 1;
            handleCheckBoxClick(activityHours[prevIndex]);
            document.getElementById(`activitydetailcardtimes_${activityHours[prevIndex].Id}`)?.focus();
        }
    };

    useEffect(() => {
        const dialog = dialogRef.current;
        if (dialog) {
            dialog.focus();
        }

        // Trap focus within dialog
        const handleTabKey = (e) => {
            if (e.key === 'Tab') {
                const focusableElements = dialog.querySelectorAll(
                    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
                );
                
                // Filter out any elements that are hidden, not visible, or disabled
                const visibleFocusableElements = Array.from(focusableElements).filter(el => {
                    const style = window.getComputedStyle(el);
                    return style.display !== 'none' && 
                           style.visibility !== 'hidden' && 
                           !el.disabled &&
                           el.offsetParent !== null;
                });
                
                const firstElement = visibleFocusableElements[0];
                const lastElement = visibleFocusableElements[visibleFocusableElements.length - 1];

                if (e.shiftKey) {
                    if (document.activeElement === firstElement || document.activeElement === dialog) {
                        lastElement.focus();
                        e.preventDefault();
                    }
                } else {
                    if (document.activeElement === lastElement) {
                        firstElement.focus();
                        e.preventDefault();
                    }
                }
            } else if (e.key === 'Escape') {
                props.onClose();
            }
        };

        // Add event listener to the dialog
        dialog?.addEventListener('keydown', handleTabKey);
        
        // Add event listener to prevent focusing outside the dialog
        const preventFocusOutside = (e) => {
            if (!dialog?.contains(e.target)) {
                e.stopPropagation();
                dialog?.focus();
            }
        };
        
        document.addEventListener('focusin', preventFocusOutside);
        
        return () => {
            dialog?.removeEventListener('keydown', handleTabKey);
            document.removeEventListener('focusin', preventFocusOutside);
        };
    }, [props]);


    return (
        <FocusTrap
        active={true}
        focusTrapOptions={{
            initialFocus: () => closeButtonRef.current,
            returnFocusOnDeactivate: true,
            escapeDeactivates: true,
        }}
        >


        <div 
            ref={dialogRef}
            role="dialog"
            aria-labelledby="upsale-dialog-title"
            aria-modal="true"
            className="card activityDetailCard border-0 rounded-0 mt-2"
            tabIndex="-1"
        >
            <div className="text-start">
                <button 
                    onClick={() => props.onClose()} 
                    className=' btn btn-icon focus-styles'
                    aria-label="סגור חלון"
                    tabIndex="1"
                    ref={closeButtonRef}

                >
                    <i className="exit-shape icon-close close" aria-hidden="true" />
                </button>
            </div>
            {isMobile ? <div className="pt-2">
                <div className="px-3">
                    <h4 id="upsale-dialog-title" className="almoni_tzar_normal text-start">מומלץ לשלב בביקור פעילות נוספת:</h4>
                    <div className="row gx-lg-4 gx-3 mt-3 mb-4">
                        <div className="col-3 col-lg-3">
                            <img 
                                className="card-img border-0" 
                                src={props.upsaleActivities?.cart_picture__c} 
                                alt={`תמונה של ${props.upsaleActivities?.Title || 'פעילות'}`} 
                            />
                        </div>
                        <div className="col-9 col-lg-9">
                            <div className="alef">
                                <div className="text-start text-mahuti fw-bold">{props.upsaleActivities?.Title || ''}</div>
                                <div className="text-start">{props.upsaleActivities?.Subtitle || ''}</div>
                            </div>
                        </div>
                    </div>
                    <hr className="gray_separator" aria-hidden="true"/>
                    <h4 id="mobile-time-selection" className="almoni_tzar_normal text-start">בחרו שעה</h4>
                    <div role="radiogroup" aria-labelledby="mobile-time-selection">
                    {activityHours && activityHours.map((item, index) => (
                        <div 
                            key={'activityHours_' + item.Id} 
                            className={`d-flex pt-3 gap-4 align-items-center pb-3 ${index !== activityHours.length - 1 ? 'bottom_separator' : ''}`}
                        >
                            <input 
                                className="text-mahuti upsale_radio invisible position-absolute" 
                                type='radio' 
                                name={'activitydetailcardtimes'} 
                                id={'activitydetailcardtimes_' + item.Id}
                                onChange={() => { handleCheckBoxClick(item) }}
                                onKeyDown={(e) => handleKeyDown(e, item)}
                                checked={selectedCheckb === item.Id}
                                aria-label={`${item.startTime} עד ${item.endTime}`}
                            />
                            <label className="text-mahuti" htmlFor={'activitydetailcardtimes_' + item.Id}>
                                {selectedCheckb === item.Id ? 
                                    <RadioChecked aria-hidden="true"/> : 
                                    <RadioEmpty aria-hidden="true"/>
                                } 
                                <span className="ms-2">{item.startTime} - {item.endTime}</span>
                            </label>
                        </div>  
                        ))}
                    </div>
                </div>
                <div className="almoni_tzar_bold text-end px-3 py-lg-2" aria-live="polite">
                    <span aria-label="תוספת מחיר">תוספת מחיר: {extraPayment}₪</span>
                </div>
                <div className="col-lg-7 col-12 d-flex justify-content-end pb-lg-5 pb-0">
                    <div id="stepperBtns" className="d-flex justify-content-end py-2 my-1">
                        <button 
                            className="btn-link prev btn step_btn almoni_tzar_normal text-decoration-none" 
                            onClick={(e) => { e.preventDefault(); props.onClose() }}
                            aria-label="סגור חלון ללא הוספת פעילות"
                        >
                            לא, תודה
                        </button> 
                        <button 
                            className={`${selectedCampaign ? "btn-primary " : 'btn-disabled'} btn step_btn`} 
                            disabled={!selectedCampaign || store.isStepFourLoading} 
                            onClick={(e) => { e.preventDefault(); props.addToCart({ ...upsaleData, campaignId: selectedCampaign.campaignId, timing: selectedCampaign, visitors: { ...props.visitors } }, true) }}>
                                <span className="almoni_tzar_normal">הוסף והמשך</span>
                                {(store.isStepFourLoading) && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>}
                        </button>
                    </div>
                </div>
            </div> :
            <><div className="card-body row">
                <div className="col-6">
                    <h2 id="upsale-dialog-title" className="card-title">
                        {upsaleData ?
                            'מומלץ לשלב בביקור פעילות נוספת:'
                            :
                            'פעילות'}
                    </h2>
                    <div className="upsale-info py-2">
                        <h3 className="header-details  d-flex justify-content-start">{props.upsaleActivities?.Title || ''}</h3> 
                        <span className="card-subtitle text-mahuti-bold mb-2 d-flex justify-content-start">{props.upsaleActivities?.Subtitle || ''}</span>
                        <p className=" text-mahuti description d-flex justify-content-start text-start">{props.upsaleActivities?.shortDescription__c || ''}</p>
                    </div>

                    <div className="flex-column pt-4">
                        {activityHours && <h5 className="header-details d-flex justify-content-start ">בחרו שעה</h5>}
                        
                        <div role="radiogroup" aria-labelledby="desktop-time-selection">
                        {activityHours && activityHours.map((item, index) => (
                            <div 
                                key={'activityHours_' + item.Id} 
                                className={`d-flex pt-3 gap-4 align-items-center ${index !== activityHours.length - 1 ? 'bottom_separator' : ''}`}
                            >
                                <div className="radio-wrapper">
                                    <input 
                                        className="radio-input"
                                        type="radio"
                                        name="activitydetailcardtimes"
                                        id={'activitydetailcardtimes_' + item.Id}
                                        onChange={() => handleCheckBoxClick(item)}
                                        onKeyDown={(e) => handleKeyDown(e, item)}
                                        checked={selectedCheckb === item.Id}
                                        aria-label={`${item.startTime} עד ${item.endTime}`}
                                        tabIndex={0}
                                    />
                                    <label 
                                        className="radio-label" 
                                        htmlFor={'activitydetailcardtimes_' + item.Id}
                                    >
                                        {selectedCheckb === item.Id ? 
                                            <RadioChecked aria-hidden="true"/> : 
                                            <RadioEmpty aria-hidden="true"/>
                                        }
                                        <span className="ms-2">{item.startTime} - {item.endTime}</span>
                                    </label>
                                </div>
                            </div>
                        ))}
                        </div>
                    </div>
                </div>

                <div className="col-6 d-flex justify-content-end">
                    <div className="d-flex align-items-end flex-column">
                        <div className="col">
                            <img 
                                className="img-thumbnail border-0 rounded-3" 
                                src={props.upsaleActivities?.cart_picture__c} 
                                alt={`תמונה של ${props.upsaleActivities?.Title || 'פעילות'}`} 
                            />
                        </div>
                        {/* <div className="align-text-bottom p-1">
                            <a href="/" className="btn btn-link text-mahuti">נקה בחירה</a>
                        </div> */}
                    </div>
                </div>
            </div>
            <hr aria-hidden="true"/>

            <div className="card-footer justify-content-between header-detail d-flex bg-body border-0 fw-bold pl-4 align-items-center">
                <div className="extra-payment" aria-live="polite">
                    <span aria-label="תוספת מחיר">תוספת מחיר: {extraPayment}₪</span>
                </div>
                    <div className="">
                        <Link 
                            className="btn-link p-3" 
                            onClick={(e) => { e.preventDefault(); props.onClose() }}
                            aria-label="סגור חלון ללא הוספת פעילות"
                        >
                            לא תודה
                        </Link>
                        <button 
                            className={selectedCampaign ? "btn-primary " : 'btn-disabled'} 
                            disabled={!selectedCampaign || store.isStepFourLoading} 
                            onClick={(e) => { e.preventDefault(); props.addToCart({ ...upsaleData, campaignId: selectedCampaign.campaignId, timing: selectedCampaign, visitors: { ...props.visitors } }, true) }}
                            aria-label={`הוסף פעילות והמשך לרכישה${!selectedCampaign ? ', נא לבחור שעה תחילה' : ''}${store.isStepFourLoading ? ', טוען...' : ''}`}
                            aria-disabled={!selectedCampaign || store.isStepFourLoading}
                            tabIndex="0"
                            >
                            <span>הוסף והמשך לרכישה</span>
                            {(store.isStepFourLoading) && (
                                <span 
                                    className="spinner-border spinner-border-sm ms-2" 
                                    role="status" 
                                    aria-hidden="true" 
                                    aria-label="טוען"
                                ></span>
                            )}
                        </button>
                    </div>
                </div></>}
            </div>
        </FocusTrap>
    )
}